import React from 'react';
import { Card } from "react-bootstrap";
import success_MateGedeon from "../../assets/img/success_MateGedeon.jpg";
import ShowMoreText from "react-show-more-text";
import proj_hidden_paths from "../../assets/img/proj_hidden_paths.png";

const Mate_Gedeon_hidden_paths = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_hidden_paths} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={success_MateGedeon}
              /* this will be the text on the banner */
              alt="Are There Hidden Paths Between Neural Networks?"
            />{" "}
            <p className="text7">Máté Gedeon</p>
            <br />
            <p className="text8">
              PhD Student{" "}
            </p>
            <p className="text8">Department of Telecommunication and Artificial Intelligence, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Training the same neural network twice can produce two models with similar accuracy but 
            very different parameter values. Are these models truly separate solutions, or are they 
            located in the same broad low-error region of the parameter space?
            <br />
            <br />
            Mode connectivity asks whether two trained solutions can be connected by a continuous path 
            in parameter space along which the model's loss remains low. Foundational studies showed 
            that such paths often exist, suggesting that apparently isolated minima may instead belong 
            to a connected low-loss region of the neural network's loss landscape. [Garipov et al., 2018; 
            Draxler et al., 2018.]
            <br />
            <br />
            The aim of this project is to explore such hidden connections between speech recognition models. 
            Students will first evaluate straight-line interpolations between compatible models and quantify 
            the performance barrier along each path. They will then investigate whether simple nonlinear curves 
            can connect selected model pairs without a substantial increase in loss.
            <br />
            <br />
            The project combines interpolation, optimization, curve analysis, and high-dimensional geometry with 
            a practical speech recognition application. Model training recipies and evaluation pipelines will be 
            provided. A basic understanding of neural networks and experience with Python are expected.
            <br />
            <br />
            Related literature:{" "}
            <br />
            <ul>
                <li>
                <a href="https://arxiv.org/abs/1802.10026">Garipov, T., Izmailov, P., Podoprikhin, D., Vetrov, D., & Wilson, A. G. (2018).
                Loss Surfaces, Mode Connectivity, and Fast Ensembling of DNNs. arXiv [Stat.ML].</a>
                </li>
                <li>
                <a href="https://proceedings.mlr.press/v80/draxler18a.html.">Draxler, F., Veschgini, K., Salmhofer, M. & Hamprecht, F. (2018). 
                Essentially No Barriers in Neural Network Energy Landscape. Proceedings of the 35th International Conference on Machine Learning, in Proceedings of Machine Learning Research 
                80:1309-1318</a>
                </li>
            
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Mate_Gedeon_hidden_paths;